import axios from "axios";

const apiUser = axios.create({
    baseURL:"https://gp-backend-production.up.railway.app/api/v1/users"
})
export default apiUser;